import { createAction, props, Action } from '@ngrx/store';
import { ApiError, FareSelectorList } from '../../client/src';

export const LOAD_TICKET_SELECTORS_TYPE =
  '[Fares/Ticket Selectors] Load Ticket Selectors';
export const loadTicketSelectors = createAction(LOAD_TICKET_SELECTORS_TYPE);

export const loadTicketSelectorsSuccess = createAction(
  `${LOAD_TICKET_SELECTORS_TYPE} Success`,
  props<{ fareSelectorList: FareSelectorList }>()
);

export const loadTicketSelectorsFailure = createAction(
  `${LOAD_TICKET_SELECTORS_TYPE} Failure`,
  props<{ error?: string | ApiError; retryAction?: Action }>()
);

export const setCustomerType = createAction(
  '[Fares/Ticket Selectors] Set Customer Type',
  props<{ customerType: string }>()
);

export const setZone = createAction(
  '[Fares/Ticket Selectors] Set Zone',
  props<{ zone: string }>()
);

export const setTravelMethod = createAction(
  '[Fares/Ticket Selectors] Set Travel Method',
  props<{ travelMethod: string }>()
);

export const setTravelTime = createAction(
  '[Fares/Ticket Selectors] Set Travel Time',
  props<{ travelTime: string }>()
);

export const setCustomerTypeTouched = createAction(
  '[Fares/Ticket Selectors] Set Customer Type Touched'
);

export const setZoneTouched = createAction(
  '[Fares/Ticket Selectors] Set Zone Touched'
);

export const setTravelMethodTouched = createAction(
  '[Fares/Ticket Selectors] Set Travel Method Touched'
);

export const setTravelTimeTouched = createAction(
  '[Fares/Ticket Selectors] Set Travel Time Touched'
);
